"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderGroupUtils = void 0;
const trade_utils_lib_1 = require("trade_utils_lib");
const TradeTypeDef_1 = require("../../ExchangeAPIAdapter/TradeTypeDef");
var OrderGroupUtils;
(function (OrderGroupUtils) {
    function _convertGroupOrderInfo(value) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        return {
            group_id: value.bu_order_data.group_id,
            quote_type: value.bu_order_data.quote_type,
            order_nums: value.bu_order_data.order_nums,
            name: value.bu_order_data.name,
            create_time: value.bu_order_data.create_time,
            quote_type_investment: value.bu_order_data.quote_type_investment,
            totalProfit: 0,
            totalProfitPercent: 0,
            positiveSubOrderTotalProfit: 0,
            negativeSubOrderTotalProfit: 0,
            current_portfolio_list: (_a = value.bu_order_data.current_portfolio_list) !== null && _a !== void 0 ? _a : [],
            group_sub_order_types: (_b = value.bu_order_data.group_sub_order_types) !== null && _b !== void 0 ? _b : [],
            group_sub_types: (_c = value.bu_order_data.group_sub_types) !== null && _c !== void 0 ? _c : [],
            position_list: (_d = value.bu_order_data.position_list) !== null && _d !== void 0 ? _d : [],
            positionValue: 0,
            state: value.bu_order_data.state,
            sub_order_list: (_f = (_e = value.bu_order_data.sub_order_list) === null || _e === void 0 ? void 0 : _e.map((item) => {
                var _a, _b, _c;
                return {
                    bu_order_id: item.bu_order_id,
                    start_time: item.start_time,
                    quote_type_investment: item.quote_type_investment,
                    quote: item.quote,
                    current_portfolio_list: (_a = item.current_portfolio_list) !== null && _a !== void 0 ? _a : [],
                    position_list: (_b = item.position_list) !== null && _b !== void 0 ? _b : [],
                    totalProfit: 0,
                    dynamic_margin: (_c = item.dynamic_margin) !== null && _c !== void 0 ? _c : "",
                    open_quote_price: new trade_utils_lib_1.SafeDecimal(item.open_quote_price).toNumber(),
                    order_status: item.order_status,
                };
            })) !== null && _f !== void 0 ? _f : [],
            create_from: (_g = value.bu_order_data.create_from) !== null && _g !== void 0 ? _g : "user",
            group_detail_hidden: (_h = value.bu_order_data.group_detail_hidden) !== null && _h !== void 0 ? _h : false,
        };
    }
    OrderGroupUtils._convertGroupOrderInfo = _convertGroupOrderInfo;
    function calcGroupOrderPositionNominalValue(item, quote, quote_type, open_quote_price, basesTickers) {
        return item.reduce((sum1, item2) => {
            const tempTicker = basesTickers === null || basesTickers === void 0 ? void 0 : basesTickers.find((item3) => item3.base === item2.base && item3.quote === quote);
            if (tempTicker !== undefined) {
                if (quote === quote_type) {
                    return sum1.add(new trade_utils_lib_1.SafeDecimal(item2.qty)
                        .mul(new trade_utils_lib_1.SafeDecimal(tempTicker.latest).div(new trade_utils_lib_1.SafeDecimal(open_quote_price).equals(0) ? 1 : new trade_utils_lib_1.SafeDecimal(open_quote_price).toNumber()))
                        .abs());
                }
                else {
                    const tempQuoteTicker = basesTickers === null || basesTickers === void 0 ? void 0 : basesTickers.find((item3) => item3.base === quote && item3.quote === quote_type);
                    if (tempQuoteTicker === undefined) {
                        return sum1.add(new trade_utils_lib_1.SafeDecimal(item2.qty).mul(new trade_utils_lib_1.SafeDecimal(tempTicker.latest)).abs());
                    }
                    else {
                        return sum1.add(new trade_utils_lib_1.SafeDecimal(item2.qty)
                            .mul(new trade_utils_lib_1.SafeDecimal(tempTicker.latest).div(new trade_utils_lib_1.SafeDecimal(open_quote_price).equals(0) ? 1 : new trade_utils_lib_1.SafeDecimal(open_quote_price).toNumber()))
                            .mul(new trade_utils_lib_1.SafeDecimal(tempQuoteTicker.latest))
                            .abs());
                    }
                }
            }
            else {
                return sum1;
            }
        }, new trade_utils_lib_1.SafeDecimal(0));
    }
    function calcGroupOrderPositionActualValue(item, quote, quote_type, open_quote_price, basesTickers) {
        return item.reduce((sum1, item2) => {
            const tempTicker = basesTickers === null || basesTickers === void 0 ? void 0 : basesTickers.find((item3) => item3.base === item2.base && item3.quote === quote);
            if (tempTicker !== undefined) {
                if (quote === quote_type) {
                    return sum1.add(new trade_utils_lib_1.SafeDecimal(item2.qty).mul(new trade_utils_lib_1.SafeDecimal(tempTicker.latest).sub(new trade_utils_lib_1.SafeDecimal(item2.avg_price).div(new trade_utils_lib_1.SafeDecimal(open_quote_price).equals(0) ? 1 : new trade_utils_lib_1.SafeDecimal(open_quote_price).toNumber()))));
                }
                else {
                    const tempQuoteTicker = basesTickers === null || basesTickers === void 0 ? void 0 : basesTickers.find((item3) => item3.base === quote && item3.quote === quote_type);
                    if (tempQuoteTicker === undefined) {
                        return sum1.add(new trade_utils_lib_1.SafeDecimal(item2.qty).mul(new trade_utils_lib_1.SafeDecimal(tempTicker.latest).sub(new trade_utils_lib_1.SafeDecimal(item2.avg_price))));
                    }
                    else {
                        return sum1.add(new trade_utils_lib_1.SafeDecimal(item2.qty)
                            .mul(new trade_utils_lib_1.SafeDecimal(tempTicker.latest).sub(new trade_utils_lib_1.SafeDecimal(item2.avg_price).div(new trade_utils_lib_1.SafeDecimal(open_quote_price).equals(0) ? 1 : new trade_utils_lib_1.SafeDecimal(open_quote_price).toNumber())))
                            .mul(new trade_utils_lib_1.SafeDecimal(tempQuoteTicker.latest)));
                    }
                }
            }
            else {
                return sum1;
            }
        }, new trade_utils_lib_1.SafeDecimal(0));
    }
    function calcGroupOrderSpotValue(item, quote, basesTickers) {
        const USDDCoin = item.find((v) => v.base === "USDT");
        return item
            .filter((v) => v.base !== "USDT")
            .reduce((sum, item1) => {
            // base 对USDT价格
            const coinUTicker = basesTickers === null || basesTickers === void 0 ? void 0 : basesTickers.find((item2) => item1.base === item2.base && item2.quote === "USDT");
            // base 对quote价格
            const baseQuoteTicker = basesTickers === null || basesTickers === void 0 ? void 0 : basesTickers.find((item2) => item1.base === item2.base && item2.quote === quote);
            // quote 对USDT价格
            const quoteUTicker = basesTickers === null || basesTickers === void 0 ? void 0 : basesTickers.find((item2) => quote === item2.base && item2.quote === "USDT");
            if (coinUTicker !== undefined) {
                return sum + coinUTicker.latest * new trade_utils_lib_1.SafeDecimal(item1.amount).toNumber();
            }
            else {
                if (baseQuoteTicker !== undefined && quoteUTicker !== undefined) {
                    return sum + baseQuoteTicker.latest * quoteUTicker.latest * new trade_utils_lib_1.SafeDecimal(item1.amount).toNumber();
                }
                else {
                    return sum;
                }
            }
        }, USDDCoin ? new trade_utils_lib_1.SafeDecimal(USDDCoin.amount).toNumber() : 0);
    }
    function __calcOrderGroupProfitImp(item, basesTickers) {
        item.sub_order_list = item.sub_order_list
            .filter((v) => {
            if (item.group_sub_types.includes(TradeTypeDef_1.ExchangeOrderType.gridV4Futures)) {
                return v.order_status === "open";
            }
            else {
                return true;
            }
        })
            .map((item1) => {
            const _subOrderCurrentPositionActualValue = calcGroupOrderPositionActualValue(item1.position_list, item1.quote, item.quote_type, item1.open_quote_price, basesTickers);
            const _subOrderCurrentPositionNominalValue = calcGroupOrderPositionNominalValue(item1.position_list, item1.quote, item.quote_type, item1.open_quote_price, basesTickers);
            const _subOrderSpotValue = calcGroupOrderSpotValue(item1.current_portfolio_list, item1.quote, basesTickers);
            let _dynamicMarginValue = new trade_utils_lib_1.SafeDecimal(0);
            if (item1.quote !== item.quote_type) {
                const tempQuoteTicker = basesTickers === null || basesTickers === void 0 ? void 0 : basesTickers.find((item3) => item3.base === item1.quote && item3.quote === item.quote_type);
                if (tempQuoteTicker !== undefined) {
                    _dynamicMarginValue = new trade_utils_lib_1.SafeDecimal(item1.dynamic_margin)
                        .div(new trade_utils_lib_1.SafeDecimal(item1.open_quote_price === 0 ? 1 : item1.open_quote_price))
                        .mul(new trade_utils_lib_1.SafeDecimal(tempQuoteTicker.latest));
                }
            }
            else {
                _dynamicMarginValue = new trade_utils_lib_1.SafeDecimal(item1.dynamic_margin);
            }
            return Object.assign(Object.assign({}, item1), { positionValue: _subOrderCurrentPositionNominalValue.toNumber(), totalProfit: _subOrderCurrentPositionActualValue
                    .add(_subOrderSpotValue)
                    .sub(new trade_utils_lib_1.SafeDecimal(item1.quote_type_investment))
                    .sub(_dynamicMarginValue)
                    .toNumber() });
        });
        item.totalProfit = item.sub_order_list.reduce((sum, item1) => {
            return sum + item1.totalProfit;
        }, 0);
        item.positionValue = item.sub_order_list.reduce((sum, item1) => {
            return sum + item1.positionValue;
        }, 0);
        item.positiveSubOrderTotalProfit = item.sub_order_list
            .filter((v) => v.totalProfit > 0)
            .reduce((sum, item1) => {
            return sum + item1.totalProfit;
        }, 0);
        item.negativeSubOrderTotalProfit = item.totalProfit - item.positiveSubOrderTotalProfit;
        item.totalProfitPercent = new trade_utils_lib_1.SafeDecimal(item.quote_type_investment).greaterThan(0)
            ? new trade_utils_lib_1.SafeDecimal(item.totalProfit).div(new trade_utils_lib_1.SafeDecimal(item.quote_type_investment)).mul(100).toNumber()
            : 0;
        return item;
    }
    OrderGroupUtils.__calcOrderGroupProfitImp = __calcOrderGroupProfitImp;
    function _calcOrderGroupProfit(item, basesTickers) {
        return Object.assign(Object.assign({}, item), { exchangeGroupOrder: __calcOrderGroupProfitImp(item.exchangeGroupOrder, basesTickers) });
    }
    OrderGroupUtils._calcOrderGroupProfit = _calcOrderGroupProfit;
})(OrderGroupUtils = exports.OrderGroupUtils || (exports.OrderGroupUtils = {}));
